<template>
	<section
		:class="[
		'block-wrapper', 
		componentClass, 
		colorMode,
		data.theme,
		style
	]" ref="wrapper"
	>
	<div v-if="data.section_title || data.text" class="row">
		<div class="small-10 medium-8 large-6 xlarge-4 small-offset-1 medium-offset-2 large-offset-3 xlarge-offset-4 columns section-top">
			<h3 class="section-title" v-text="data.section_title"></h3>
			<p class="section-intro" v-if="data.text">{{ data.text }}</p>
		</div>
	</div>
	<div class="row key-numbers-boxes-wrapper">
		<div :class="['columns', 'small-12', {
				'medium-10 medium-offset-1 large-8 large-offset-2' : (keyNumbersCount<=4),
				'xlarge-10 xlarge-offset-1': (keyNumbersCount===5)
			}]">
			<div :class="['row', 'align-middle', {
				'small-up-2 large-up-4' : (keyNumbersCount<=4),
				'small-up-2 large-up-3 xlarge-up-5': (keyNumbersCount===5)
			}]">
				<div v-for="(keyNumBox, index) in data.key_numbers_boxes"
					:key="data.component_id + '-' + index"
					:class="['columns']">
					<article :class="['key-numbers-box', style]">
						<img :src="keyNumBox.icon.src" :alt="keyNumBox.icon.alt" />
						<h6>{{ keyNumBox.title }}</h6>
						<span v-if="keyNumBox.farge" class="line" :style="'background:'+keyNumBox.farge"></span>
						<h2 v-if="style==='card'">
							<strong>
								<animated-number :number="keyNumBox.number" :separator="' '" :speed="45" :ready="animate" /><span v-if="keyNumBox.unit">{{ keyNumBox.unit }}</span>
							</strong> 
							{{ keyNumBox.text }}
						</h2>
						<div v-if="style!=='card'">
							<h2>{{ keyNumBox.number }}<span v-if="keyNumBox.unit"> {{ keyNumBox.unit }}</span></h2>
							<p>{{ keyNumBox.text }}</p>
						</div>
					</article>
				</div>
			</div>
		</div>
	</div>
	<div v-if="data.link" class="row">
		<div class="small-10 medium-8 large-6 xlarge-4 small-offset-1 medium-offset-2 large-offset-3 xlarge-offset-4 columns">
			<a 
				:href="data.link.url" 
				aria-role="button" 
				tabindex="0" 
				class="wysiwyg-link"
				@keyup.enter.stop.prevent="goToLink" 
				v-on:click.stop.prevent="goToLink">
				{{ data.link.title }}
			</a>
		</div>
	</div>
  </section>
</template>


<script>
import BaseBlock from "./Base";

export default {
	extends: BaseBlock,
	data() {
		return {
			defaultColorMode: 'light',
			componentClass: 'key-numbers-section',
			animationTriggerYOffset: window.innerHeight,
			animate: false
		}
	},
	computed: {
		style() {
			return (typeof this.data.theme !== 'undefined' && this.data.theme !== 'default') ? 'card' : 'default';
		},
		keyNumbersCount() {
			if (typeof this.data.key_numbers_boxes === 'undefined') return 4;
			return this.data.key_numbers_boxes.length || 4;
		}
	},
	methods: {
		goToLink() {
			var lang = this.$store.state.lang;
			this.$router.push({
				params: {
					lang: lang,
					slug: this.data.slug
				}
			})
		},
		handleScroll() {
			if (window.pageYOffset > this.animationTriggerYOffset) {
				window.removeEventListener('scroll', this.handleScroll)
				this.animate = true
			}
		},
		setYOffset() {
			if (typeof this.$refs.wrapper === 'undefined' || typeof this.$refs.wrapper.getBoundingClientRect() === 'undefined') return;
			this.animationTriggerYOffset = this.$refs.wrapper.getBoundingClientRect().top - window.innerHeight;
		}
	},
	components: {
		AnimatedNumber: () => import("../global/parts/AnimatedNumber")
	},
	mounted() {
		this.setYOffset();
		window.addEventListener('scroll', this.handleScroll)
		window.addEventListener('resize', this.setYOffset)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setYOffset)
		if (!this.animate) {
			window.removeEventListener('scroll', this.handleScroll)
		}
	}
}
</script>

<style lang="scss">
	@import "../../styles/scss/component/key-numbers";
	@import "../../styles/scss/component/wysiwyg/link";
</style>